<div class="workSpace">
  <!--nombre y filtro-->
  <div class="w3-container w3-containertemplate" style="height: 7%;">
    <!--Nombre modulo y tablero-->
    <div class="w3-caja-menu padreizquierda w3-veinte">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate}}</b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }}</span>
      </div>
    </div>
    <!--FILTROS-->
    <div class="w3-caja-menu padreizquierda w3-rest ">
      <div class="zonasFiltros w3-row centradoVertical ">
        <div class="w3-thirty ">
            <div class="w3-right" style="margin-right: 5%;" [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
              {{ 'filtros.rango' | translate }}
            </div>
            <div class="w3-right" style="margin-right: 5%; margin-top: 1%;">
              <input (click)="activacionFiltros()" class="" style="border-width: 1px;" type="checkbox">
            </div>
        </div>
        <div class="w3-rest"  [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
          {{ 'filtros.desde' | translate }}
  
          @for (anio of Periodos; track $index) {
            @for (mes of anio.series; track $index) {
              <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
              [matMenuTriggerFor]="menuAniosIni">
                <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
              </div>
            }
          }
          <mat-menu class="w3-medium" #menuAniosIni="matMenu">
            @for (anio of Periodos; track $index) {
              <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses">
                {{anio.anio}}
              </button>
              <mat-menu #menuMeses="matMenu" [overlapTrigger]="false">
                @for (mes of anio.series; track $index) {
                  <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes, 'inicio');">
                    <input [id]="'check_'+mes.mes+''+mes.anio"
                    (change)="cambioPeriodo(mes, 'inicio')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                    [checked]="mes.check" type="checkbox"
                    (click)="$event.stopPropagation();">
                    <span style="margin-left: 5px; float: left;">{{'filtros.'+mes.mes|translate}}</span> 
                  </button>
                }
              </mat-menu>
            }
          </mat-menu>
  
          {{ 'filtros.hasta' | translate }}
  
          @for (anio of Periodos2; track $index) {
            @for (mes of anio.series; track $index) {
              <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
              [matMenuTriggerFor]="menuAniosFin">
                <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
              </div>
            }
          }
          <mat-menu class="w3-medium" #menuAniosFin="matMenu">
            @for (anio of Periodos2; track $index) {
              @if (anio.visible) {
                <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses2">
                  {{anio.anio}}
                </button>
              }
              <mat-menu #menuMeses2="matMenu" [overlapTrigger]="false">
                @for (mes of anio.series; track $index) {
                  @if (mes.visible) {
                    <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes, 'fin');">
                      <input [id]="'check_'+mes.mes+''+mes.anio"
                      (change)="cambioPeriodo(mes, 'fin')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                      [checked]="mes.check" type="checkbox"
                      (click)="$event.stopPropagation();">
                      <span style="margin-left: 5px; float: left;">{{'filtros.'+mes.mes|translate}}</span> 
                    </button>
                  }
                }
              </mat-menu>
            }
          </mat-menu>
        </div>
      </div>
    </div>
    
  </div>
  <!--Contenido Tablero-->
  <div class="w3-row workSpaceTab ">
    <div class="zonaIzq">
      <div class="w3-row  w3-titulo-contenidomenuSC">
        <div class="w3-threequarter">
          <span class="w3-margin-left-contenido">{{'operative.mapa.titulo1' | translate}}</span>
          @if (filtroPeriodos) {
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
          }
        </div>
      </div>
      <div class="izq w3-white">
        <div class="w3-row headers w3-titulo-contenidomenuSC">
          <div class="w3-rest w3-right">
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuTabla1">
                more_vert
            </mat-icon>
            <mat-menu #menuTabla1="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarMapa(1)">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="contenido w3-scroll">
          <table class="w3-table">
            <thead>
              <tr class="w3-center" style="line-height: 1 !important;">
                <th class="w3-white stikyColumCon w3-border-right-balance"></th>
                <th colspan="4" class="stikyColumCon w3-table-titleLow">{{'operative.mapa.enc1' | translate}}</th>
              </tr>
              <tr style="line-height: 1 !important;">
                <th class="w3-table-titleLow w3-center stikyColumCon2 w3-border-right-balance w3-border-bottom-balance">{{'operative.mapa.enc2' | translate}}</th>
                @for (i of tit1; track $index) {
                  <th class="w3-table-title w3-center stikyColumCon2 w3-border-right-balance">{{i.nombre}}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (v of valores1; track v; let j = $index) {
                <tr class="w3-table-trtd borderInfLow w3-center" style="line-height: 1 !important;">
                  <td class="w3-table-title w3-border-bottom-balance">{{tit2[j].nombre}}</td>
                  @for (d of v; track d; let k = $index) {
                    <td class="borderAllLow" [ngStyle]="{'background-color': colorSup(j,k)}" (click)="actTabla(j,k,1)" 
                    style="cursor: pointer;" matTooltip="Mostrar eventos">
                      @if (d.num !== 0) { {{d.num}} }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        
        <div class="contenidoDetalle">
          <div class="w3-row w3-right" style="margin-bottom: 1%; margin-right: 2%;">
            <table class=" w3-table">
              <thead>
                <td><mat-icon style="color: #4CAF50;" class="iconoMen">circle</mat-icon></td>
                <td><span>Muy Bajo</span></td>
                <td><mat-icon style="color: #7ce980;" class="iconoMen">circle</mat-icon></td>
                <td style="font-size: 8;"><span >Bajo</span></td>
                <td><mat-icon style="color: #ffeb3b;" class="iconoMen">circle</mat-icon></td>
                <td><span>Medio</span></td>
                <td><mat-icon style="color: #FF8300;" class="iconoMen">circle</mat-icon></td>
                <td><span>Alto</span></td>
                <td><mat-icon style="color: #f44336;" class="iconoMen">circle</mat-icon></td>
                <td><span>Muy Alto</span></td>
              </thead>
            </table>
          </div>
          <div class="w3-row headers w3-titulo-contenidomenuSC">
            <div  class="w3-row  w3-titulo-contenidomenuSC ">
              <div class="w3-noventa2">
                <span class="w3-margin-left-contenido">{{'operative.mapa.titulo' + matriz | translate}} &bull; </span>
                @if (matriz === 1) {
                  <span style="font-weight: lighter;" >{{'operative.mapa.enc2' | translate}} {{enc2}} | {{'operative.mapa.enc1' | translate}} {{enc1}}</span>
                }
                @if (matriz === 2) {
                  <span style="font-weight: lighter;">{{'operative.mapa.enc4' | translate}} {{enc4}} | {{'operative.mapa.enc3' | translate}} {{enc3}}</span>
                }
                @if (filtroPeriodos) {
                  <span class="w3-margin-left-contenido">&bull;</span>
                  <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
                }
              </div>
              <div class="w3-rest w3-right ">
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                  [matMenuTriggerFor]="menuTabla2">
                    more_vert
                </mat-icon>
                <mat-menu #menuTabla2="matMenu">
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarTabla(matriz)">
                    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>              
          </div>
          <div class="contenidoTabla w3-scroll">
            <table class="w3-table">
              <thead>
                <tr class="w3-center">
                  <th class="w3-table-title w3-center stikyColumCon w3-border-right-balance">{{'operative.mapa.enc5' | translate}}</th>
                  <th class="w3-table-title w3-center stikyColumCon w3-border-right-balance">{{'operative.mapa.enc6' | translate}}</th>
                  <th class="w3-table-title w3-center stikyColumCon w3-border-right-balance">{{'operative.mapa.enc7' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                @for (dato of mostrarModal; track $index) {
                  <tr class="w3-table-trtd borderInfLow w3-center" style="line-height: 1 !important;">
                    <td class="borderAllLow">{{getCate(dato.categorias)}}</td>
                    <td class="borderAllLow">{{getEvent(dato)}}</td>
                    <td class="borderAllLow">{{dato.num}}</td>
                  </tr>
                }
              </tbody>
            </table>
            @if (num === 0) {
              <div style="height: 60%; width: 98%; padding-top: 2vh;" class="w3-center"> Lista de eventos vacía, seleccione otra combinación de la matriz. </div>
            }
          </div>
        </div>
      </div>
      
    </div> 
    <div class="zonaDer">
      <div class="w3-row w3-titulo-contenidomenuSC">
        <div class="w3-threequarter">
          <span class="w3-margin-left-contenido">{{'operative.mapa.titulo2' | translate}}</span>
          @if (filtroPeriodos) {
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
          }
        </div>
      </div>
      <div class="izq w3-white">
        <div class="w3-row headers w3-titulo-contenidomenuSC">
          <div class="w3-rest w3-right">
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuTabla3">
                more_vert
            </mat-icon>
            <mat-menu #menuTabla3="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarMapa(2)">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="contenido2 w3-scroll">
          <table class="w3-table">
            <thead>
              <tr class=" w3-center" style="line-height: 1 !important;">
                <th class="w3-white stikyColumCon w3-border-right-balance"></th>
                <th [attr.colspan]="tit3.length" class="stikyColumCon w3-table-titleLow">{{'operative.mapa.enc3' | translate}}</th>
              </tr>
              <tr style="line-height: 1 !important;">
                <th class="w3-table-titleLow w3-center stikyColumCon2 w3-border-right-balance w3-border-bottom-balance">{{'operative.mapa.enc4' | translate}}</th>
                @for (i1 of tit3; track $index) {
                  <th class="w3-table-title w3-center stikyColumCon2 w3-border-right-balance">{{i1.nombre}}%</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (v1 of valores2; track v1; let j1 = $index) {
                <tr class="w3-table-trtd borderInfLow w3-center" style="line-height: 1 !important;">
                  <td class="w3-table-title w3-border-bottom-balance">{{tit4[j1].nombre}}</td>
                  @for (d1 of v1; track d1; let k1 = $index) {
                    <td class="borderAllLow" [ngStyle]="{'background-color': colorInf(j1,k1)}" (click)="actTabla(j1,k1,2)" style="cursor: pointer;">
                      @if (d1.num !== 0) { {{d1.num}} }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      
    </div>
  </div>
</div>
  